import { DevIdsQueryParams } from '../../../pure-js/types/QueryParamTypes'
import { User } from '../../../pure-js/types/User'
import useQueryParams from '../libs/useQueryParams'
import { useUser as useUserFromApiLayer } from '../apiLayer'
import useAppState from './useAppState'
import config from '../Config'

export function useUser(id?: string) {
  const { state } = useAppState()
  const qp = useQueryParams<DevIdsQueryParams>()

  const uid = id || getUidFromQueryParams(qp) || state.user.id

  const query = useUserFromApiLayer(uid)

  // Use apiLayer data or fallback to state.user
  const userData = query.data?.data || state.user

  return { data: userData, isLoading: query.isLoading } as { data: User; isLoading: boolean }
}

// `?uid=` renders the app as another user on dev builds. Display only — reads stay authorized
// server-side against the caller's own token.
export const getUidFromQueryParams = (qp: DevIdsQueryParams) => {
  if (config.enableDevelop && qp.uid) return qp.uid

  return undefined
}
